(() => {
  const leafEmojiPattern = /[\u{1F331}\u{1F33F}-\u{1F343}\u{1FAB4}]\uFE0F?/u;
  const leafEmojiGlobalPattern = /[\u{1F331}\u{1F33F}-\u{1F343}\u{1FAB4}]\uFE0F?/gu;
  const leafDecorationSelector = [
    '.falling-leaf',
    '.falling-leaves',
    '.leaf-fall',
    '.leaf-particle',
    '[data-falling-leaf]',
    '[data-leaf-particle]'
  ].join(',');

  const removeLeafDecorations = (root = document) => {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(leafDecorationSelector)) {
      root.remove();
      return;
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(leafDecorationSelector).forEach((element) => element.remove());
    }

    const textRoot = root.nodeType === Node.TEXT_NODE ? root.parentNode : root;
    if (!textRoot) return;

    const walker = document.createTreeWalker(textRoot, NodeFilter.SHOW_TEXT);
    const leafNodes = [];

    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      if (leafEmojiPattern.test(textNode.nodeValue || '')) leafNodes.push(textNode);
    }

    leafNodes.forEach((textNode) => {
      const parent = textNode.parentElement;
      const cleanedText = (textNode.nodeValue || '').replace(leafEmojiGlobalPattern, '');

      if (
        parent &&
        cleanedText.trim() === '' &&
        parent.childNodes.length === 1 &&
        parent.matches('span, div, i, b, em')
      ) {
        parent.remove();
      } else {
        textNode.nodeValue = cleanedText;
      }
    });
  };

  const initLeafCleanup = () => {
    if (document.documentElement.dataset.farceLeafCleanup === 'true') return;

    document.documentElement.dataset.farceLeafCleanup = 'true';
    removeLeafDecorations(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          removeLeafDecorations(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => removeLeafDecorations(node));
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  const moneyFromPage = () => {
    const price = document.querySelector('.product-section .product__price .price-item--sale:not([hidden]), .product-section .product__price .price-item--regular');
    return price ? price.textContent.trim() : '';
  };

  const initMobileAtc = (root = document) => {
    const sticky = root.querySelector('[data-farce-mobile-atc]') || document.querySelector('[data-farce-mobile-atc]');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const sectionId = sticky.dataset.productSection;
    const nativeButton = document.querySelector(`#shopify-section-${CSS.escape(sectionId)} .product-form__submit`) ||
      document.querySelector('.product-section .product-form__submit');
    const stickyButton = sticky.querySelector('[data-farce-mobile-atc-button]');
    const stickyPrice = sticky.querySelector('.farce-mobile-atc__price');
    if (!nativeButton || !stickyButton) return;

    sticky.dataset.initialized = 'true';

    const sync = () => {
      stickyButton.disabled = nativeButton.disabled;
      const nativeLabel = nativeButton.querySelector('span');
      if (nativeLabel && nativeLabel.textContent.trim()) {
        stickyButton.textContent = nativeLabel.textContent.trim();
      }
      const visiblePrice = moneyFromPage();
      if (stickyPrice && visiblePrice) stickyPrice.textContent = visiblePrice;
    };

    stickyButton.addEventListener('click', () => {
      sync();
      if (!nativeButton.disabled) nativeButton.click();
    });

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && window.scrollY > 180;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0.2 });

    observer.observe(nativeButton);
    new MutationObserver(sync).observe(nativeButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('.product-section')) window.setTimeout(sync, 80);
    });

    sync();
  };

  const init = (root = document) => {
    initLeafCleanup();
    initMobileAtc(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
